import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import CardActionArea from "@material-ui/core/CardActionArea";
import {
  exportDocument,
  cardHeight,
  redirect,
  analyticsTagTrigger,
} from "../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const renderContent = ({ card, cards, dark, containerized }) => (
  <div>
    <div
      className="card-img-top  text-center text-white"
      style={{
        backgroundColor: card.bgcolor || "#0f69b4",
        height: cardHeight(cards) * 90,
      }}
    >
      {!!card.licenceType && (
        <div className="pt-2" style={{}}>
          <h1
            style={{
              fontWeight: "bold",
              margin: "0px",
              fontSize: "50px",
            }}
          >
            {card.licenceType}
          </h1>
        </div>
      )}
      {!!card.icon ? (
        !!card.icon.includes("/") ? (
          <div className={`${!!card.licenceType ? "pt-0" : "pt-2"} pb-3`}>
            <img
              src={card.icon}
              alt={card.title || "imagen referencial"}
              width="100"
              height="105"
            />
          </div>
        ) : (
          <div className={`${!!card.licenceType ? "pt-1" : "pt-3"} pb-3`}>
            <FontAwesomeIcon
              icon={card.icon || "file-download"}
              size={card.iconSize || "4x"}
            />
          </div>
        )
      ) : null}
      {card.iconSubtitle && (
        <div
          style={{
            marginTop: "-20px",
          }}
        >
          <small>{card.iconSubtitle}</small>
        </div>
      )}
    </div>
    <CardContent className="pb-1">
      <div className="card-body py-0 px-0 mx-0 text-center">
        <h5
          className={`font-weight-bold ${dark ? "text-light" : ""}`}
          style={{
            color: dark ? "#A0A0A0" : "#0f69b4",
            fontSize: containerized ? "15px" : "20px",
          }}
        >
          {card.title}
        </h5>
        <p
          className={`card-text ${dark ? "text-white-50" : ""}`}
          style={{
            fontSize: containerized ? "12px" : "15px",
            minHeight: containerized ? "70px" : "63px",
          }}
        >
          {card.text}
        </p>
      </div>
    </CardContent>
    <CardActions className="p-0 pb-3 mt-0 pt-1">
      <Button
        variant="contained"
        color="primary"
        className="m-auto"
        onClick={() => exportDocument(card.redirect, card.tab || false)}
      >
        <Typography variant="subtitle2" className="m-auto">
          {card.buttonTitle}
        </Typography>
      </Button>
    </CardActions>
  </div>
);

const actionRender = (props) => (
  <CardActionArea
    onClick={() => redirect(props.card.cardRedirect, props.history)}
  >
    {renderContent(props)}
  </CardActionArea>
);

const CardRowMaterial = (props) => {
  let history = useHistory();
  const { cards, containerized } = props;
  return (
    <Grid container spacing={1} alignItems="stretch">
      {cards.map((card, key) => (
        <Grid key={key} item lg={containerized ? 4 : 3} md={6} xs={12}>
          <Card onClick={() => !!card.tag && analyticsTagTrigger(card.tag)}>
            {card.cardRedirect
              ? actionRender({ card, history, ...props })
              : renderContent({ card, ...props })}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

CardRowMaterial.propTypes = {
  cards: PropTypes.array,
};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(CardRowMaterial);
